import { defineMessages } from '@jutro/locale';

export default defineMessages({
    watercraftNeedYourAttention: {
        id: 'ml.gateway.MLWatercraftListPopup.Watercraft marked with a (!) need your attention',
        defaultMessage: 'Watercraft marked with a (!) need your attention.'
    },
    clickEditLink: {
        id: 'ml.gateway.MLWatercraftListPopup.Please click the edit link and fill out all the required fields.',
        defaultMessage: 'Please click the edit link and fill out all the required fields.'
    },
    watercraftExposures: {
        id: 'ml.policychange.MLWatercraftListPopup.Watercraft exposures',
        defaultMessage: 'Watercraft exposures',
    },
    reviewThisInfoAndMakeChanges: {
        id: 'ml.policychange.MLWatercraftListPopup.Review this information and make changes as needed',
        defaultMessage: 'Review this information and make changes as needed',
    }
    
});
